export default __webpack_public_path__ + "2dd27cf6ccdd1107a4a49d21a205186c.svg";